import React from 'react';
import { HelmetProvider } from 'react-helmet-async';

const Header = () => {
  return (
    <HelmetProvider>
      <meta charSet="UTF-8" />
      <title>GSI</title>
      <meta name="viewport" content="width=device-width,initial-scale=1.0" />
      <meta 
        name="description" 
        content="Geneseq - Genomic Solutions for a Healthier Future. Genomic Information, Synthesis, Food & Infectious Disease Testing." 
      />
      <meta 
        name="keywords" 
        content="Genomics, Sequencing, Synthesis, Food Testing, Infectious Disease, Laboratory" 
      />
      <meta name="author" content="Geneseq" />
      <link 
        href="https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap" 
        rel="stylesheet" 
      />
      <link rel="icon" href="/imgs/favicon.ico" type="image/x-icon" />
      <link rel="stylesheet" href="/assets/swiper-bundle.min.css" />
      <link rel="stylesheet" href="/assets/glightbox.min.css" />
      <link 
        rel="stylesheet" 
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css" 
      />
      <link rel="stylesheet" href="/styles.css" />
    </HelmetProvider>
  );
};

export default Header;